import React, { useState, useEffect } from "react";
import { Building2, Users, Database, Megaphone, Handshake, Gift, Globe, Activity } from "lucide-react";
import api from "@/lib/api";
import { Loading, SectionHeader, SupportBadge } from "./shared";

const Stat = ({ icon: Icon, label, value, testid }) => (
  <div className="min-w-0 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5" data-testid={testid}>
    <div className="flex min-w-0 items-start gap-2 text-[#3E7256]"><Icon size={16} className="mt-0.5 shrink-0" /><span className="min-w-0 break-words text-[11px] font-semibold uppercase leading-tight tracking-wider text-slate-400 sm:text-xs">{label}</span></div>
    <p className="mt-2 break-words font-heading text-3xl font-bold text-[#17201A]">{value}</p>
  </div>
);

export default function AdminOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <Loading />;
  const c = data.counts, a = data.activity, s = data.support;
  return (
    <div data-testid="admin-overview" className="min-w-0">
      <SectionHeader title="Vue d'ensemble" subtitle="État du système Lodge & Co en temps réel." />
      <div className="grid min-w-0 grid-cols-1 gap-4 min-[360px]:grid-cols-2 md:grid-cols-4">
        <Stat icon={Building2} label="Organisations" value={c.organizations} testid="stat-orgs" />
        <Stat icon={Users} label="Utilisateurs" value={c.users} testid="stat-users" />
        <Stat icon={Database} label="Imports" value={c.imports} testid="stat-imports" />
        <Stat icon={Activity} label="Points de données" value={c.data_points} testid="stat-datapoints" />
        <Stat icon={Megaphone} label="Campagnes" value={c.campaigns} testid="stat-campaigns" />
        <Stat icon={Handshake} label="Partenariats actifs" value={`${c.partnerships_active}/${c.partnerships}`} testid="stat-partnerships" />
        <Stat icon={Gift} label="Parrainages" value={c.referrals} testid="stat-referrals" />
        <Stat icon={Globe} label="GSA activé" value={c.gsa_enabled} testid="stat-gsa" />
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="overview-activity">
          <h3 className="mb-3 font-heading text-sm font-bold text-[#17201A]">Activité récente (7 jours)</h3>
          <div className="flex items-center justify-between border-b border-slate-100 py-2 text-sm"><span className="text-slate-500">Nouveaux imports</span><span className="font-semibold text-[#17201A]">{a.recent_imports_7d}</span></div>
          <div className="flex items-center justify-between py-2 text-sm"><span className="text-slate-500">Nouveaux utilisateurs</span><span className="font-semibold text-[#17201A]">{a.recent_users_7d}</span></div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="overview-support">
          <h3 className="mb-3 font-heading text-sm font-bold text-[#17201A]">Statut support par organisation</h3>
          <div className="flex flex-wrap gap-3">
            {Object.entries(s).map(([k, v]) => (
              <div key={k} className="flex items-center gap-2 text-sm"><SupportBadge status={k} /><span className="font-semibold text-[#17201A]">{v}</span></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
